module.exports = __webpack_public_path__ + "img/tpc-35.3ea33a8f.jpg";